import { Div } from '@tblabs/truffle';


export class Svg extends Div
{
    constructor(svg: string)
    {
        super();
        this.Class("svg");
        this.Html(svg);
    }
}
